export const PASSWORD_POLICY_LENGTHS = [8, 12, 15, 20, 24];

const POLICY_MODES = [
  { prefix: "MINIMO", labelKey: "minimo_caracteres_senha" },
  { prefix: "LETRAS_NUMEROS", labelKey: "senha_letras_numeros" },
  {
    prefix: "LETRAS_MAIUSCULAS_NUMEROS",
    labelKey: "senha_letras_maiusculas_numeros",
  },
  {
    prefix: "MAIUSCULAS_MINUSCULAS_NUMEROS",
    labelKey: "senha_maiusculas_minusculas_numeros",
  },
  {
    prefix: "LETRAS_NUMEROS_ESPECIAIS",
    labelKey: "senha_letras_numeros_especiais",
  },
  {
    prefix: "LETRAS_MAIUSCULAS_NUMEROS_ESPECIAIS",
    labelKey: "senha_letras_maiusculas_numeros_especiais",
  },
  {
    prefix: "MAIUSCULAS_MINUSCULAS_NUMEROS_ESPECIAIS",
    labelKey: "senha_completa",
  },
];

export function getPasswordPolicyOptions(t) {
  return [
    { text: t("sem_exigencia_adicional"), value: "SEM_EXIGENCIA_ADICIONAL" },
    ...POLICY_MODES.flatMap((mode) =>
      PASSWORD_POLICY_LENGTHS.map((length) => ({
        text: t(mode.labelKey).replace("{quantidade}", length),
        value: `${mode.prefix}_${length}`,
      }))
    ),
  ];
}

export function getPasswordPolicy(tipo) {
  for (const mode of POLICY_MODES) {
    for (const length of PASSWORD_POLICY_LENGTHS) {
      if (tipo === `${mode.prefix}_${length}`) {
        return { ...mode, minLength: length };
      }
    }
  }
  return { prefix: null, labelKey: null, minLength: 6 };
}

export function passwordMeetsPolicy(password, tipo) {
  const policy = getPasswordPolicy(tipo);
  const value = String(password || "");
  if (value.length < policy.minLength) return false;
  switch (policy.prefix) {
    case "LETRAS_NUMEROS":
      return /\p{L}/u.test(value) && /\p{Nd}/u.test(value);
    case "LETRAS_MAIUSCULAS_NUMEROS":
      return /\p{Lu}/u.test(value) && /\p{Nd}/u.test(value);
    case "MAIUSCULAS_MINUSCULAS_NUMEROS":
      return (
        /\p{Ll}/u.test(value) && /\p{Lu}/u.test(value) && /\p{Nd}/u.test(value)
      );
    case "LETRAS_NUMEROS_ESPECIAIS":
      return (
        /\p{L}/u.test(value) &&
        /\p{Nd}/u.test(value) &&
        /[^\p{L}\p{N}\s]/u.test(value)
      );
    case "LETRAS_MAIUSCULAS_NUMEROS_ESPECIAIS":
      return (
        /\p{Lu}/u.test(value) &&
        /\p{Nd}/u.test(value) &&
        /[^\p{L}\p{N}\s]/u.test(value)
      );
    case "MAIUSCULAS_MINUSCULAS_NUMEROS_ESPECIAIS":
      return (
        /\p{Ll}/u.test(value) &&
        /\p{Lu}/u.test(value) &&
        /\p{Nd}/u.test(value) &&
        /[^\p{L}\p{N}\s]/u.test(value)
      );
    default:
      return true;
  }
}

export function passwordPolicyLabel(tipo, t) {
  const policy = getPasswordPolicy(tipo);
  return policy.labelKey
    ? t(policy.labelKey).replace("{quantidade}", policy.minLength)
    : t("Senha_minimo_caracteres").replace("{quantidade}", 6);
}
